import { render, staticRenderFns } from "./erro.vue?vue&type=template&id=19284288&scoped=true&"
import script from "./erro.vue?vue&type=script&lang=js&"
export * from "./erro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19284288",
  null
  
)

export default component.exports